import { motion } from "framer-motion";
import { DownloadSimple, Archive } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { toast } from "sonner";

export function PerformanceReports({ reports }) {
  const downloadReport = async (report) => {
    try {
      const res = await api.get(`/reports/${report.id}/pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `IGC-Report-${report.month_label}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("Could not generate report PDF. Please try again.");
    }
  };

  const recent = reports.slice(0, 3);

  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.25 }} className="bg-igc-surface border border-igc-gold/15 p-6" data-testid="performance-reports-card">
      <div className="flex items-center justify-between mb-4">
        <p className="text-igc-muted text-xs uppercase tracking-widest">Performance Reports</p>
        {reports.length > 0 && (
          <Link to="/client/archive" data-testid="view-full-archive-link" title="Opens the full archive of every monthly report ever generated for your store." className="flex items-center gap-1.5 text-xs text-igc-goldText hover:text-igc-goldHover transition-colors">
            <Archive size={14} /> View Full Archive
          </Link>
        )}
      </div>
      {recent.length === 0 && <p className="text-igc-muted text-sm">No monthly reports yet.</p>}
      <div className="space-y-2">
        {recent.map((r) => (
          <div key={r.id} className="flex items-center justify-between border-b border-igc-gold/5 py-2" data-testid={`report-row-${r.id}`}>
            <span className="text-igc-cream text-sm">{r.month_label} Summary</span>
            <button
              data-testid={`download-report-${r.id}`}
              onClick={() => downloadReport(r)}
              title="Downloads this month's performance report as a PDF."
              className="flex items-center gap-1.5 text-xs text-igc-goldText hover:text-igc-goldHover transition-colors border border-igc-gold/30 px-3 py-1.5"
            >
              <DownloadSimple size={14} /> Download
            </button>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
